import React from 'react';
import classNames from 'classnames';
import { HippoComponentProps } from '../index';

import styles from './Badge.module.scss';

export interface Props extends HippoComponentProps {
  value: number;
  type: 'primary' | 'notification' | 'search';
}

const Badge: React.FC<Props> = ({ value, type, dataQA, className }) => {
  return (
    <span
      data-qa={dataQA}
      className={classNames(styles.container, styles[type], className)}
    >
      {value > 99 ? '99+' : value}
    </span>
  );
};

export default Badge;
